{
  "manager": {
    "actionsCreate": {
      "loadingConfiguration": "Loading action configuration...",
      "tryAgain": "Try again",
      "actionDetailsTitle": "Action Details",
      "actionNameLabel": "Action Name *",
      "actionNameDescription": "Give this automation a descriptive name.",
      "nameRequiredFeedback": "This field is required.",
      "namePlaceholder": "e.g., Send welcome email for summer camp signups",
      "automationFlowTitle": "Automation Flow",
      "automationFlowDescription": "Define when this action should trigger and what should happen.",
      "whenThisHappens": "When this happens...",
      "onlyWhen": "Only when...",
      "filterBy": "Filter by",
      "valueLabel": "Value",
      "conditionValuePlaceholder": "Enter value...",
      "thenDoThis": "Then do this...",
      "withTheseSettings": "With these settings...",
      "emailTemplateLabel": "Email Template",
      "emailTemplateFeedback": "Please select an email template.",
      "fixTheFollowing": "Please fix the following:",
      "selectTriggerEvent": "Select a trigger event",
      "selectAnAction": "Select an action",
      "specifyConditionValue": "Specify a condition value",
      "selectActionParameter": "Select an action parameter",
      "previewLabel": "Preview:",
      "saveAction": "Save Action"
    },
    "actionsIndex": {
      "title": "Actions"
    }
  }
}
